"use client";

import { usePathname } from "next/navigation";
import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";

import { isPublicBookingRoute } from "@calcom/web/lib/metaTracking/Runtime";

import { posthogAnalytics } from "./client";

export default function PostHogTrackingRuntime() {
  const pathname = usePathname();
  const { data: session, status } = useSession();
  const lastPathname = useRef<string | null>(null);
  const previousDistinctId = useRef<string | null>(null);
  const enabled = isPublicBookingRoute(pathname);

  useEffect(() => {
    const user = session?.user;
    const distinctId = user?.id?.toString();

    if (!enabled || !posthogAnalytics.isConfigured() || status === "loading") {
      if (!enabled && previousDistinctId.current) {
        posthogAnalytics.reset();
        previousDistinctId.current = null;
      }
      return;
    }

    posthogAnalytics.init();
    if (!user || !distinctId) {
      if (previousDistinctId.current) posthogAnalytics.reset();
      previousDistinctId.current = null;
      return;
    }

    if (previousDistinctId.current === distinctId) return;
    if (previousDistinctId.current) posthogAnalytics.reset();

    posthogAnalytics.identify(distinctId, {
      email: user.email ?? undefined,
      name: user.name ?? undefined,
      role: user.role ?? undefined,
    });
    previousDistinctId.current = distinctId;
  }, [session, status]);

  useEffect(() => {
    if (!enabled || !posthogAnalytics.isConfigured()) {
      if (!enabled) lastPathname.current = null;
      return;
    }

    posthogAnalytics.init();
    if (lastPathname.current !== pathname) {
      lastPathname.current = pathname;
      posthogAnalytics.pageView(pathname ?? "");
    }
  }, [enabled, pathname]);

  return null;
}
